import { debounce } from '../utils';

jQuery(document).ready(() => {
  /**
   *
   * Menu
   *
   */

  const burger = $('.navbar-burger');

  burger.click((event, element) => {
    let menuId = burger.data('target');
    burger.toggleClass('is-active');
    $('#' + menuId).toggleClass('is-active');
    $('html').toggleClass('is-clipped');
  });

  /**
   *
   * AlignFull JS solution
   *
   */
  const blockWorkFull = () => {
    let bodyWidth = $('body').width();
    $('.wp-block-wrap').each((index, el) => {
      $(el).css({
        paddingLeft: 0, // Reset fix padding
        paddingRight: 0, // Reset fix padding
        marginLeft: 'calc( -' + bodyWidth + 'px / 2 + 100% / 2 )',
        marginRight: 'calc( -' + bodyWidth + 'px / 2 + 100% / 2 )',
        maxWidth: bodyWidth,
      });
    });
  };

  blockWorkFull();
  $(window).resize(debounce(blockWorkFull, 50));
});
